export default function Contact() {
    return(
        <div>
            <h2>Contact Information</h2>
            <p style={{marginLeft: '1em'}}>
                Computational Theory and Application Lab (CTAL)<br/>
                Daegu Gyeongbuk Institute of Science and Technology (DGIST)<br/>
                333 Techno Jungang-daero, Hyeonpung-eup, Dalseong-gun<br/>
                Daegu, Republic of Korea, 42988<br/>
                <br/>
                📧: <a href="mailto:ekwoo@dgist.ac.kr">ekwoo@dgist.ac.kr</a>
            </p>
        </div>
    );
}